"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useIsNewField(fields) {
    const fieldsRef = react_1.useRef(fields);
    react_1.useEffect(() => {
        fieldsRef.current = fields;
    }, [fields]);
    function isNewField(field) {
        return !fieldsRef.current.some(f => f.key === field.key);
    }
    return isNewField;
}
exports.default = useIsNewField;
